import { render, staticRenderFns } from "./NovaPoshtaEditingPage.vue?vue&type=template&id=b01d62f8"
import script from "./NovaPoshtaEditingPage.vue?vue&type=script&lang=js"
export * from "./NovaPoshtaEditingPage.vue?vue&type=script&lang=js"
import style0 from "./NovaPoshtaEditingPage.vue?vue&type=style&index=0&id=b01d62f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports